import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { surfaceSx } from './dashboardStyles';

// Placeholder that mirrors the real layout (status strip, strategy cards, trends)
// so the page doesn't jump when the data lands.

const Line = ({ width = '100%', height = 14, sx }) => (
  <Skeleton variant="text" animation="wave" width={width} height={height} sx={sx} />
);

export function StatusStripSkeleton() {
  return (
    <Box sx={{ ...surfaceSx, overflow: 'hidden' }}>
      <Box sx={{ px: 2, py: 1.25, borderBottom: '1px solid #e2e8f0', display: 'flex', gap: 2 }}>
        <Line width={140} />
        <Line width={110} />
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(5, 1fr)' } }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <Box key={i} sx={{ px: 2, py: 1.5, borderRight: i < 4 ? '1px solid #e2e8f0' : 'none' }}>
            <Line width={70} height={12} />
            <Line width={110} height={28} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export function StrategyCardSkeleton() {
  return (
    <Box sx={{ ...surfaceSx, p: 2, mb: 2, minHeight: 360 }}>
      <Line width={180} height={22} />
      <Skeleton variant="rounded" animation="wave" height={74} sx={{ mt: 1.5, borderRadius: '6px' }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1.5, mt: 2 }}>
        {[0, 1, 2, 3].map((i) => (
          <Box key={i}>
            <Line width="60%" height={12} />
            <Line width="80%" height={20} />
          </Box>
        ))}
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, mt: 2 }}>
        <Skeleton variant="rounded" animation="wave" height={64} sx={{ borderRadius: '6px' }} />
        <Skeleton variant="rounded" animation="wave" height={64} sx={{ borderRadius: '6px' }} />
      </Box>
      <Line width="70%" sx={{ mt: 2.5 }} />
      <Line width="55%" />
    </Box>
  );
}

export function TrendsSkeleton({ height = 340 }) {
  return <Skeleton variant="rounded" animation="wave" height={height} sx={{ borderRadius: '6px' }} />;
}

export default function RiskFrameworkSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }} aria-busy="true" aria-label="Loading risk framework">
      <StatusStripSkeleton />
      <Box>
        <Line width={220} height={18} />
        <Line width={260} height={14} sx={{ mb: 1 }} />
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' }, columnGap: 2 }}>
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <StrategyCardSkeleton key={i} />
          ))}
        </Box>
      </Box>
      <TrendsSkeleton />
    </Box>
  );
}
